export const LanguageInput = () => {
  return (
    <select name="lang">
      <option key="pt-BR" value="pt-BR">Português</option>
      <option key="en-US" value="en-US">English</option>
    </select>
  );
}
export default LanguageInput;
